/*
Speaker created using standard javascript library
Supported by almost all browser
We will eventually move towards Google textToSpeech

The component read a text passed in the PropsTypes
This is a basic version with start and dispose (no way to pause and continue)
*/
import React, { Component } from 'react';
import { 
    Button,
    Spinner } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeadphones } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types';

library.add(faHeadphones)

export default class Speaker extends Component {

  state = {
      speakPressed: false,
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSpeechEnd = (e) => {
    console.log('Reading finished');
    this.setState({
        speakPressed: false
    });
  }

  speakClick = (e) => { 
    if (!this.state.speakPressed) {
        //start reading
        if ('speechSynthesis' in window) {
            var msg = new SpeechSynthesisUtterance();
            console.log(msg);
            var voices = window.speechSynthesis.getVoices();
            console.log(voices);
            msg.voice = voices[4];//Microsoft Elsa voice
            msg.rate = 1;
            msg.pitch = 1;
            msg.lang = 'en'
            msg.text = this.props.text;
            msg.onend = this.onSpeechEnd;
            speechSynthesis.speak(msg);
        }else{
            console.log('speechSynthesis not supported');
            //let's open a modal or dialog to aware the user
        }
    }else{
        //stoppare lo speech
        speechSynthesis.cancel();//questo comando cancella tutti i text in coda
    }
    this.setState({
        speakPressed: !this.state.speakPressed
    });
  }

  render() {

    var speakIcon;
    if (this.state.speakPressed) {
        speakIcon = <Spinner style={iconSize} type="grow" color="light" />;
    } else {
        speakIcon = <FontAwesomeIcon style={iconSize} icon="headphones" />;
    }

    var buttonStyle;
    if(this.props.text === ""){
        buttonStyle = {
            display: 'none'
        }
    }else{
        buttonStyle = {
            display: 'inline'
        }
    }

    return (
        <React.Fragment>
            <Button style={buttonStyle} onClick={this.speakClick}>{speakIcon}</Button>
        </React.Fragment>
    );
  }
}

const iconSize = {
    width: '1rem', 
    height: '1rem'
}

Speaker.propTypes = {
    text: PropTypes.string.isRequired //variable that contains the text to read
}
